import { UserInsolvencyTierDto } from '../../../config/finance/financeConfig'
import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { baseListStyles } from '../../List/BaseList'
import useCurrency from '../../../hooks/useCurrency'
import useUsers from '../../../hooks/useUsers'
import { Stack, Text } from '@fluentui/react'
import MoneyText from '../../Text/Currency/MoneyText'
import { UserTierListItemProps } from './UserTierListItem'
import { InsolvencyModuleDto } from '../../../hooks/module/useFileModule'
import { useSettings } from '../../../hooks/useSettings'
import { formatNumber } from '../../../helpers/numberHelper'
import { useTranslation } from 'react-i18next'

export type UserInsolvencyTierListItemProps = UserTierListItemProps<UserInsolvencyTierDto> & {
    insolvencyModule: InsolvencyModuleDto
}

export function UserInsolvencyTierListItem(props: UserInsolvencyTierListItemProps): ReactElement {
    const { t: translate } = useTranslation()
    const { currency } = useCurrency(props.item.currency)
    const settings = useSettings()
    const { users } = useUsers()

    const user = useMemo(() => users.find(user => user.id === props.item.userId), [props.item.userId])
    const role = useMemo(
        () => settings.insolvency?.roles?.find(role => role.key === props.item.role),
        [props.item.role],
    )

    const factorExperience = useMemo(
        () => formatNumber(props.item.factorExperience, '0.0'),
        [props.item.factorExperience],
    )
    const factorEstate = useMemo(() => formatNumber(props.item.factorEstate, '0.0'), [props.item.factorEstate])
    const factorTotal = useMemo(() => formatNumber(props.item.factorTotal, '0.0'), [props.item.factorTotal])

    return (
        <Stack horizontal styles={{ root: baseListStyles.itemCell }} onClick={() => props.editTier(props.index)}>
            <Stack horizontal={false} style={{ flexGrow: 1, minWidth: 0 }} tokens={{ childrenGap: 's2' }}>
                <Text>{user?.fullName || '?'}</Text>
                <Text>{role?.name || '?'}</Text>
                <Stack horizontal tokens={{ childrenGap: 's2' }}>
                    <Text>{translate('file.edit.form.finance.rates.tier.purchaserate')}: </Text>
                    <MoneyText amount={props.item.salesRate} currency={currency} />
                </Stack>
            </Stack>
            <Stack horizontal={false} horizontalAlign={'end'} tokens={{ childrenGap: 's2' }}>
                <Text>
                    {translate('file.edit.form.finance.rates.tier.factorexperience')} {factorExperience}
                </Text>
                <Text>
                    {translate('file.edit.form.finance.rates.tier.factorestate')}: {factorEstate}
                </Text>
                <Text>
                    {translate('file.edit.form.finance.rates.tier.factortotal')}: {factorTotal}
                </Text>
            </Stack>
        </Stack>
    )
}
